export const getGermanCurrencyFormat = string => {
  if (!string) return
  return parseFloat(string).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
